import { render, staticRenderFns } from "./SpecListChoose.vue?vue&type=template&id=73afda3f&scoped=true&"
import script from "./SpecListChoose.vue?vue&type=script&lang=js&"
export * from "./SpecListChoose.vue?vue&type=script&lang=js&"
import style0 from "./SpecListChoose.vue?vue&type=style&index=0&id=73afda3f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afda3f",
  null
  
)

export default component.exports